import React from 'react';
import { Link } from 'react-router-dom';

import {
  formatPhoneNumber,
  normalizePhone,
} from '../../../../../lib/utils/formatters';
import { address, highlightMatches } from '../helpers';
import { fromISO } from '../../../../../lib/utils/datetime_formatters';

export default function UserHit({ hit }) {
  return (
    <article className="py-3 border-b w-full" key={hit.id} id='search_result'>
      <Link
        className="text-lg font-avenir-black text-primary-blue cursor-pointer flex"
        to={hit.company_id ? `/companies/${hit.company_id}` : `/accounts/${hit.account_id}`}
      >
        <span className="underline">
          {hit.first_name} {hit.last_name}
        </span>
        <span className="inline-flex items-center rounded-md ml-2 mb-1 px-3 py-0.5 pt-[0.2rem] capitalize font-avenir-book text-xs tracking-wide bg-violet-100 text-violet-600">
          User
        </span>
      </Link>
      <div className="capitalize grid grid-cols-1 md:grid-cols-3 gap-3 md:gap-6">
        <div className="text-sm font-avenir-book">
          <p>ID: {hit.id}</p>
          <p>Created: {fromISO(hit.created_at).toLocaleString()}</p>
          Match: {highlightMatches(hit)}
        </div>
        <p className="text-sm">
          <span className="block normal-case">Email: {hit.email}</span>
          <span className="block">Address: {address(hit.address)}</span>
        </p>
        <div className="text-sm">
          <span className="block">
            Phone: {formatPhoneNumber(normalizePhone(hit?.phone))}
          </span>
          <span className="block">
            DOB: {fromISO(hit.birthdate).toLocaleString()}
          </span>
        </div>
      </div>
    </article>
  );
}
